import styled from 'styled-components';
import { brandIsPh } from '@/shared/config/brand-by-target.mjs';
import { BannerStyle as BonusBannerStyle } from '@/features/news-management/ui/bonus-banner/styles';

export const BannerStyle = styled(BonusBannerStyle)`
  @media (max-width: 768px) {
    aspect-ratio: ${brandIsPh ? '430 / 215' : '752 / 376'};
    border-radius: 12px;
  }
`;
